"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const SettingsPopover_1 = __importDefault(require("../SettingsPopover"));
function SettingBar({ pageIndex, pageSize, pageSizes, pageLength, loading, rowCount, totalCount, disablePagination, disableSettings, disableGroupBy = false, gotoPage, previousPage, nextPage, setPageSize, styles, columnsGroupingComponent, columnsSelectorComponent, canPreviousPage = false, canNextPage = false, }) {
    const [settingsAnchor, setSettingsAnchor] = react_1.default.useState(null);
    const handleSettingsClick = (event) => {
        setSettingsAnchor(event.currentTarget);
    };
    const handleSettingsClose = () => {
        setSettingsAnchor(null);
    };
    const settingsOpen = Boolean(settingsAnchor);
    const settingsId = settingsOpen ? 'settings-popover' : undefined;
    const settingsPopoverProps = {
        pageSize,
        pageSizes,
        settingsId,
        loading,
        settingsOpen,
        disableGroupBy,
        gotoPage,
        settingsAnchor,
        handleSettingsClose,
        setPageSize,
        styles,
        columnsGroupingComponent,
        columnsSelectorComponent,
    };
    if (!(disablePagination && disableSettings)) {
        return (react_1.default.createElement("div", null,
            !disablePagination && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.IconButton, { size: "small", "aria-label": "first page", disabled: pageIndex === 0 || loading, "data-testid": "first-page", onClick: () => gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(0) },
                    react_1.default.createElement(icons_1.FirstPage, null)),
                react_1.default.createElement(core_1.IconButton, { size: "small", "aria-label": "previous page", disabled: !canPreviousPage || loading, "data-testid": "previous-page", onClick: previousPage },
                    react_1.default.createElement(icons_1.NavigateBefore, null)),
                react_1.default.createElement("span", null, `${pageIndex * pageSize + 1}-${pageIndex * pageSize + pageLength} of ${totalCount}`),
                react_1.default.createElement(core_1.IconButton, { "aria-label": "next page", size: "small", disabled: !canNextPage || loading, "data-testid": "next-page", onClick: nextPage },
                    react_1.default.createElement(icons_1.NavigateNext, null)),
                react_1.default.createElement(core_1.IconButton, { "aria-label": "last page", size: "small", "data-testid": "last-page", disabled: pageIndex * pageSize + pageLength >= rowCount || loading, onClick: () => gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(Math.ceil(rowCount / pageSize) - 1) },
                    react_1.default.createElement(icons_1.LastPage, null)))),
            !disableSettings && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.IconButton, { size: "small", "aria-label": "settings", className: styles.leftSpace, "aria-describedby": settingsId, disabled: loading, "data-testid": "settings", onClick: handleSettingsClick },
                    react_1.default.createElement(icons_1.SettingsOutlined, { fontSize: "small" })),
                react_1.default.createElement(SettingsPopover_1.default, Object.assign({}, settingsPopoverProps))))));
    }
    return null;
}
exports.default = SettingBar;
//# sourceMappingURL=index.js.map